var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAustralia = function SvgAustralia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 24,
    x: 1,
    y: 4,
    fill: "#061b65",
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.5 13.774V16h4v-2.227L13.537 16H16v-1.241L12.238 12H16V8h-2.74L16 5.991V4h-1.441L10.5 6.977V4h-4v2.794L3.243 4.405a4 4 0 0 0-1.786 1.738l2.532 1.858H1v4h3.763L1 14.761v1.24h2.464z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M1.805 5.589 5.09 8h1.364L2.359 4.995q-.307.27-.554.594M1 16l5.454-4v1l-4.091 3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.838 18.741.536 1.666 1.636-.62-.968 1.457 1.505.893-1.743.152.24 1.733-1.205-1.268-1.205 1.268.24-1.733-1.743-.152 1.505-.893-.968-1.457 1.636.62.536-1.666ZM23.113 21.755l.291.906.89-.337-.527.793.819.486-.948.082.131.943-.656-.69-.656.69.131-.943-.948-.082.819-.486-.527-.793.89.337zM20.166 13.127l.291.906.89-.337-.527.793.819.486-.948.082.131.943-.656-.69-.656.69.131-.943-.948-.082.819-.486-.527-.793.89.337zM23.43 7.127l.291.906.89-.337-.527.793.819.486-.948.082.131.943-.656-.69-.656.69.131-.943-.948-.082.819-.486-.527-.793.89.337zM28.132 10.817l.291.906.89-.337-.527.793.819.486-.948.082.131.943-.656-.69-.656.69.131-.943-.948-.082.819-.486-.527-.793.89.337zM25.742 16l.23.565.608.045-.466.393.146.592-.518-.321-.518.321.146-.592-.466-.393.608-.045z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M9.5 16h-2v-5H1V9h6.5V4h2v5H16v2H9.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#d22d32",
    d: "M16 15.667 11 12v1l4.091 3H16zM16 4h-.248l-5.461 4.004h1.364L16 4.818z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 4H5a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4m3 20c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V8c0-1.654 1.346-3 3-3h22c1.654 0 3 1.346 3 3z",
    opacity: 0.15
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 5H5a3 3 0 0 0-3 3v1a3 3 0 0 1 3-3h22a3 3 0 0 1 3 3V8a3 3 0 0 0-3-3",
    opacity: 0.2
  })));
};
export default SvgAustralia;